/* Match model variant options before Shopify counts and paginates products. */
(() => {
  const key = 'filter.v.option.model';
  const normalize = value => String(value).toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i')
    .replace(/([0-9])(?=[a-z])/g,'$1 ').replace(/pro\s*max/g,'pro max').replace(/\s+/g,' ').trim();
  const names = {'pro max':'Pro Max',pro:'Pro',plus:'Plus',mini:'Mini',air:'Air',ultra:'Ultra',fe:'FE'};
  function models(term) {
    const text=normalize(term);
    // A number is a model only at the start; a named iPhone can occur later.
    const iphone=text.match(/^(?:apple\s+)?(?:iphone\s*)?(1[1-9])(?:\s+(pro max|pro|plus|mini|air))?(?=\s|$)/)
      || text.match(/\biphone\s*(1[1-9])(?:\s+(pro max|pro|plus|mini|air))?(?=\s|$)/);
    if(iphone){
      const base=`iPhone ${iphone[1]}`;
      if(iphone[2])return [base+' '+names[iphone[2]]];
      return [base,...['Pro','Pro Max','Plus','Mini','Air'].map(s=>base+' '+s)];
    }
    const samsung=text.match(/^(?:samsung\s+)?(?:galaxy\s+)?s\s*(2[0-9])(?:\s+(ultra|plus|fe))?(?=\s|$)/);
    if(samsung){const tail='S'+samsung[1]+(samsung[2]?' '+names[samsung[2]]:'');return ['Galaxy '+tail,'Samsung '+tail];}
    return [];
  }
  function collectionModels(url){
    const handle=decodeURIComponent(url.pathname).match(/\/collections\/([^/]+)\/?$/)?.[1];
    if(!handle)return [];
    const iphone=handle.match(/^iphone-(1[1-9])(?:-(pro-max|pro|plus|mini|air))?-kiliflari$/);
    if(iphone)return [`iPhone ${iphone[1]}`+(iphone[2]?' '+names[iphone[2].replace(/-/g,' ')]:'')];
    const samsung=handle.match(/^(?:samsung|galaxy)-s(2[0-9])(?:-(ultra|plus|fe))?-kiliflari$/);
    if(samsung){const tail='S'+samsung[1]+(samsung[2]?' '+names[samsung[2]]:'');return ['Galaxy '+tail,'Samsung '+tail];}
    return [];
  }
  function setValues(url,values){url.searchParams.delete(key);values.forEach(v=>url.searchParams.append(key,v));}
  function apply(url,term){
    const values=models(term);url.searchParams.set('q',term);
    if(!values.length)return false;
    url.searchParams.set('type','product');setValues(url,values);return true;
  }
  function applyCollection(url){
    const values=collectionModels(url);if(!values.length)return false;
    const before=url.searchParams.getAll(key);
    if(before.length===values.length&&values.every(v=>before.includes(v)))return false;
    setValues(url,values);url.searchParams.delete('page');return true;
  }
  window.MPCModelSearch={models,apply,collectionModels,applyCollection};
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement))return;
    const input=form.querySelector('input[name="q"]');
    if(!input||!new URL(form.action,location.origin).pathname.endsWith('/search'))return;
    const url=new URL(form.action,location.origin);if(!apply(url,input.value.trim()))return;
    event.preventDefault();event.stopImmediatePropagation();location.assign(url.toString());
  },true);
  // Add the exact model filter to menu links before navigation (no extra request).
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('a[href]');if(!a)return;
    const url=new URL(a.href,location.origin);
    if(url.origin===location.origin&&applyCollection(url))a.href=url.toString();
  },true);
  const current=new URL(location.href);
  if(!current.searchParams.has('section_id')&&!current.searchParams.has('sections')){
    if(current.pathname.endsWith('/search')){
      const term=current.searchParams.get('q')||'';const values=models(term);
      const existing=current.searchParams.getAll(key);
      // Preserve deliberate facet choices; repair unfiltered model searches.
      if(values.length&&!existing.length){apply(current,term);current.searchParams.delete('page');location.replace(current.toString());}
    }else if(applyCollection(current))location.replace(current.toString());
  }
})();
